import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {GlobalVariable} from './../global';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl: string = GlobalVariable.BASE_URL;
  
  constructor(private http: HttpClient, private auth: AuthService) { }
  
  getYearList() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/dropdown/getyears';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getContract(YearMonth: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/clientjoborder/contractlist?startDate='+YearMonth;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  getAssociates(YearMonth: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/user/by-approver?weekEnding=' + YearMonth;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get<any>(apiUrl, { headers });
  }

  sendEmailNotification(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/logagreement/bulk-email-notification";
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.post<any>(targetUrl, Obj,{ headers });
  }

  getContractDetails(jobOrderId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/clientjoborderdetails/'+jobOrderId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get<any>(apiUrl, { headers });
    
  }
}
